import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { ValidationSettings } from "@cs-ts/validation-settings";
import { CalculationContext } from "./__CalculationContextInterface";
import { parseBool } from "../../lib/calculations";
import { combineLatest } from "rxjs";
import { map } from "rxjs/operators";
export default class ValidationDef extends BaseElementDef<ValidationSettings, FormDefinitionItem<ValidationSettings>, FormItem> {
    declare associatedElements: string[];
    declare customErrorId: string;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<ValidationSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFValidation"; // TODO - not hardcoded?
        this.customErrorId = this.vmId + "_Errors";
        /** @type {string[]} */
        this.associatedElements = this.associatedElements || [];
        this.isFocusable = true; // To properly get custom validation as invalid element
    }

    setData(data: FormItem | null, excludeChildren?: boolean) {
        super.setData(data, excludeChildren);
        this.setKey(data, "associatedElements", "associatedElements");
    }

    valid$() {
        if (!this.definition.settings.serverSide || this.calculationContext.adminPreview) {
            const result = this.resolveCalculation(this.definition.settings.calculationId!, this.definition.settings.legacyCalculation);
            return result.pipe(map(value => value.reduce((a, i) => a || parseBool(i) === 1, false)));
        } else {
            return super.valid$();
        }
    }

    errors$() {
        if (!this.definition.settings.serverSide || this.calculationContext.adminPreview) {
            return combineLatest([this.valid$(), ...this.associatedElements.map(id => this.getRoot().getElementsById$(id))]).pipe(
                map(([valid, ...elements]) => {
                    Array.prototype.concat.apply([], elements).forEach(element => {
                        const errorIds = element.customErrorIds;
                        const errorIndex = errorIds.indexOf(this.customErrorId);
                        if (valid && errorIndex >= 0) {
                            errorIds.splice(errorIndex, 1);
                        } else if (!valid && errorIndex === -1) {
                            errorIds.push(this.customErrorId);
                        }
                        element._customErrorIds$.next(errorIds);
                    });
                    return valid ? [] : [this.definition.settings.errorMessage!];
                }),
            );
        } else {
            return super.errors$();
        }
    }
}
